"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toggle = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _ = require("../../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** A toggle component used to show / hide / expand content  */
var Toggle =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Toggle, _React$Component);

  function Toggle(props) {
    var _this;

    _classCallCheck(this, Toggle);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Toggle).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "state", {
      expanded: false,
      disabled: false
    });

    _defineProperty(_assertThisInitialized(_this), "toggleExpand", function () {
      if (!_this.props.disabled) {
        _this.setState({
          expanded: !_this.state.expanded
        });
      }
    });

    _this.state = _objectSpread({}, props);
    return _this;
  }

  _createClass(Toggle, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          disabled = _this$state.disabled,
          expanded = _this$state.expanded;
      var _this$props = this.props,
          children = _this$props.children,
          label = _this$props.label,
          textSize = _this$props.textSize,
          renderSecondaryAction = _this$props.renderSecondaryAction;
      return _react.default.createElement(_.Flex, {
        width: "100%",
        flexDirection: "column",
        pb: 2
      }, _react.default.createElement(_.Separator, {
        mb: 2
      }), _react.default.createElement(Header, {
        onClick: this.toggleExpand,
        disabled: disabled
      }, _react.default.createElement(_.Flex, {
        justifyContent: "space-between",
        alignItems: "center"
      }, _react.default.createElement(_.Sans, {
        size: textSize,
        weight: "medium",
        color: "black100",
        my: 0.5
      }, label), _react.default.createElement(_.Flex, {
        justifyContent: "right",
        alignItems: "center"
      }, renderSecondaryAction && renderSecondaryAction({
        disabled: disabled,
        expanded: expanded,
        textSize: textSize
      }), _react.default.createElement(_.ChevronIcon, {
        style: {
          visibility: disabled ? "hidden" : "visible"
        },
        direction: expanded ? "up" : "down",
        width: 12,
        height: 12,
        ml: 1
      })))), expanded && children && _react.default.createElement(_.Flex, {
        flexDirection: "column",
        alignItems: "left"
      }, children));
    }
  }]);

  return Toggle;
}(_react.default.Component);

exports.Toggle = Toggle;

_defineProperty(Toggle, "defaultProps", {
  textSize: "2"
});

Toggle.displayName = "Toggle";

var Header = _styledComponents.default.div.withConfig({
  displayName: "Toggle__Header",
  componentId: "sc-1yxwor4-0"
})(["cursor:pointer;pointer-events:", ";user-select:none;", ";"], function (props) {
  return props.disabled ? "none" : "auto";
}, _styledSystem.space);

Header.displayName = "Header";
//# sourceMappingURL=Toggle.js.map